import { createContext, useContext, ReactNode } from "react";

import { useProfile } from "../hooks/profile/useProfile";

import { ProfileCompletionField, UserProfile } from "../types/user/userProfile";

type ProfileContextType = {
  profile: UserProfile | null;
  incompleteProfile: boolean;
  missingProfileFields: ProfileCompletionField[];
  loading: boolean;
  error: string | null;
  getProfile: () => Promise<void>;
  updateLocalProfile: (data: Partial<UserProfile>) => void;
  clearProfile: () => void;
  pictureUrl: string | null;
  setPicture: (picture: Blob | null) => void;
};

const ProfileContext = createContext<ProfileContextType | null>(null);

export const ProfileProvider = ({ children }: { children: ReactNode }) => {
  const profileHook = useProfile();

  return (
    <ProfileContext.Provider value={profileHook}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfileContext must be used within ProfileProvider");
  return ctx;
};
